import React from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import { makeStyles } from '@material-ui/core/styles'
import { COLOR_DARKEST_GRAY } from 'src/constants'

const useStylesBootstrap = makeStyles(theme => ({
  arrow: {
    color: COLOR_DARKEST_GRAY
  },
  tooltip: {
    backgroundColor: COLOR_DARKEST_GRAY
  }
}))
export const BootstrapTooltip = props => {
  const classes = useStylesBootstrap()
  return <Tooltip arrow classes={classes} {...props} />
}
